namespace GeniuzPOS.QRreport {
    export interface QRywcSpecRow {
        Id?: number;
        ReportId?: string;
        ReportName?: string;
        UrlReport?: string;
        DataStructureName?: string;
        LineNo?: number;
        DateBegin?: string;
        DateEnd?: string;
        ShopId?: string;
        PosId?: string;
        DayOfWeek?: string;
        DocTime?: string;
        SalemanId?: string;
        MbId?: string;
        PluCode?: string;
        CatCode?: string;
        SubCat1Code?: string;
        SubCat2Code?: string;
        BrandCode?: string;
        StyleId?: string;
        ColorId?: string;
        SizeId?: string;
        TasteId?: string;
        MatTypeId?: string;
        SupplId?: string;
        ConsignFg?: number;
        PromoCampaign?: string;
        PromoId?: string;
        PaymentType?: number;
        LineItemType?: string;
        DiscCouponType?: string;
        WcText?: string;
        WcNumberic?: string;
        CreateBy?: string;
        CreateDate?: string;
        CashierId?: string;
        DocTimeStart?: string;
        DocTimeEnd?: string;
        DocMonth?: string;
        DocYear?: string;
        DocMonthEnd?: string;
        DocYearEnd?: string;
        ShopTypeId?: string;
        ShopGroupId?: string;
        WhsId?: string;
        GruopType?: number;
        Qty_AmtFg?: number;
        SkuCode?: string;
        PmType?: number;
        PmGroupFg?: number;
        ShopFg?: number;
        PmTypeFg?: number;
        PmGroupId?: string;
        MbType?: string;
        pSequenFg?: pSequenFg;
    }

    export namespace QRywcSpecRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ReportId';
        export const localTextPrefix = 'QRreport.QRywcSpec';
        export const lookupKey = 'QRreport.QRywcSpec';

        export function getLookup(): Q.Lookup<QRywcSpecRow> {
            return Q.getLookup<QRywcSpecRow>('QRreport.QRywcSpec');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            ReportId = "ReportId",
            ReportName = "ReportName",
            UrlReport = "UrlReport",
            DataStructureName = "DataStructureName",
            LineNo = "LineNo",
            DateBegin = "DateBegin",
            DateEnd = "DateEnd",
            ShopId = "ShopId",
            PosId = "PosId",
            DayOfWeek = "DayOfWeek",
            DocTime = "DocTime",
            SalemanId = "SalemanId",
            MbId = "MbId",
            PluCode = "PluCode",
            CatCode = "CatCode",
            SubCat1Code = "SubCat1Code",
            SubCat2Code = "SubCat2Code",
            BrandCode = "BrandCode",
            StyleId = "StyleId",
            ColorId = "ColorId",
            SizeId = "SizeId",
            TasteId = "TasteId",
            MatTypeId = "MatTypeId",
            SupplId = "SupplId",
            ConsignFg = "ConsignFg",
            PromoCampaign = "PromoCampaign",
            PromoId = "PromoId",
            PaymentType = "PaymentType",
            LineItemType = "LineItemType",
            DiscCouponType = "DiscCouponType",
            WcText = "WcText",
            WcNumberic = "WcNumberic",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            CashierId = "CashierId",
            DocTimeStart = "DocTimeStart",
            DocTimeEnd = "DocTimeEnd",
            DocMonth = "DocMonth",
            DocYear = "DocYear",
            DocMonthEnd = "DocMonthEnd",
            DocYearEnd = "DocYearEnd",
            ShopTypeId = "ShopTypeId",
            ShopGroupId = "ShopGroupId",
            WhsId = "WhsId",
            GruopType = "GruopType",
            Qty_AmtFg = "Qty_AmtFg",
            SkuCode = "SkuCode",
            PmType = "PmType",
            PmGroupFg = "PmGroupFg",
            ShopFg = "ShopFg",
            PmTypeFg = "PmTypeFg",
            PmGroupId = "PmGroupId",
            MbType = "MbType",
            pSequenFg = "pSequenFg"
        }
    }
}
